import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-finance",
  "use": "icon-soc-l1-finance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-finance\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M512 160c176 0 320 112 320 288S688 736 512 736 192 624 192 448s144-288 320-288zm0 96c-128 0-224 80-224 192s96 192 224 192 224-80 224-192-96-192-224-192z\" />\r\n  <path d=\"M480 288h64v64h64v64H544v64h-64v-64h-64v-64h64V288z\" />\r\n  <path d=\"M288 800h448v64H288v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-finance.svg
// module id = vMG0
// module chunks = 492